import { MappedResponse } from 'Models/Generics/BFF';

const capitalizeSnakeWord = (text = '', i: number) => (i !== 0 ? text[0]?.toUpperCase() ?? '' : text[0])
  + text.substring(1).toLowerCase();

export const snakeToCammel = (text: string) => text.toLowerCase().split('_').map(capitalizeSnakeWord).join('');

/**
 * @function mapToAurora
 *
 * `snake_case` is a Ruby convention, therefore all of their response payloads follows
 * said format; lucky us, Javascript convention is cammelCase, so we are constantly
 * mapping BFF responses (manually) into cammelCase.
 *
 * This function recursively transforms the entire schema to `cammelCase`.
 *
 * @param payload An Object in snake_case
 * @returns Parsed result
 */
export const mapToAurora = <P>(payload: P): MappedResponse<P> => {
  if (!(payload instanceof Object)) return payload as MappedResponse<P>;
  if (Array.isArray(payload)) return payload.map(mapToAurora) as MappedResponse<P>;
  return Object
    .entries(payload)
    .reduce(
      (result, [key, value]) => ({
        ...result,
        [snakeToCammel(key)]: mapToAurora(value),
      }),
      {},
    ) as MappedResponse<P>;
};
